/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import intermoji from '@intercom/intermoji';
export const INPUT_RULE_EMOJI = {
  type: 'custom',
  matcher: /(\s|^):([\w-]+):$/,
  handler(state, match, start, end) {
    let identifier = match[2];
    if (!intermoji.isSupportedIdentifier(identifier)) {
      return;
    }
    let emoji = intermoji.unicodeFromIdentifier(identifier);
    return state.tr.insertText(emoji, start + match[1].length, end);
  }
};